/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityShippingListPage = lazyLoad(
  () => import('./index'),
  module => module.EntityShippingList
);
